import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';

import { setIntendedReferrerCompanyId } from '../store/slices/intendedInfoSlice';

import DA from '../store/ReduxAccess';

const condensedOrgFacePanelStyles = {
  entityProfileFrame_titleBoxContainer: {},
  entityProfileFrame_titleBox: {
    height: '58px',
    width: '395px',
    display: 'flex',
    alignItems: 'center',
  },
  entityProfileFrame_titleIcon: {
    height: '50px',
    width: '50px',
    margin: '0 10px 0 15px',
    position: 'relative',
    display: 'flex',
  },
  entityProfileFrame_titleBox_text: {
    display: 'flex',
    flexFlow: 'column nowrap',
    width: 'calc(100% - 75px)',
    '&:after': {
      content: '',
      clear: 'both',
    },
  },
  entityProfileFrame_title: {
    color: '#0c0d0d',
    fontFamily: 'MetricWebBold',
    fontSize: '1.3rem',
    fontWeight: 400,
    lineHeight: '28px',
    cursor: 'pointer',
    '&:hover': {
      // color: "#0c0dee",
      textDecoration: 'underline',
    },
  },
  entityProfileFrame_subtitle: {
    color: '#0c0d0d',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '19px',
  },
  profileImageComponent: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    textAlign: 'center',
    backgroundColor: '#dce3e6',
    color: 'rgba(12,13,13,0.32)',
    position: 'relative',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '50px',
  },
  profileImageComponent_circle: {
    verticalAlign: 'center',
    borderRadius: '50%',
  },
  u_ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

class CondensedOrgFacePanel extends React.Component {
  state = {
    redirect: undefined,
  };

  redirectToFirmWithId(firmId) {
    this.props.setIntendedReferrerCompanyId(firmId);
    this.setState({ redirect: 'referrerOrg' });
  }

  computeFirmTypeAbbreviation(firmType) {
    const firstSpaceLoc = firmType.indexOf(' ');
    const firstLetter = firmType.charAt(0);
    if (firstSpaceLoc) {
      const secondLetter = firmType.charAt(firstSpaceLoc + 1);
      return (firstLetter + secondLetter).toUpperCase();
    } else {
      return firstLetter.toUpperCase();
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    const { classes, visibleFirmId, contacts } = this.props;
    const firm = DA.getFirmById(visibleFirmId);
    const firmName = firm.name;
    const nContacts = contacts.length;
    const nContactsStr = nContacts === 1 ? nContacts + ' Contact' : nContacts + ' Contacts';
    const firmType = firm.firmType;
    const firmTypeAbbrev = this.computeFirmTypeAbbreviation(firmType);
    return (
      <div className={classes.entityProfileFrame_titleBoxContainer}>
        <div className={classes.entityProfileFrame_titleBox}>
          {false && (
            <div className={classes.entityProfileFrame_titleIcon}>
              <div className={cx(classes.profileImageComponent, classes.profileImageComponent_circle)}>
                {firmTypeAbbrev}
              </div>
            </div>
          )}
          <div className={classes.entityProfileFrame_titleBox_text}>
            <div
              className={cx(classes.entityProfileFrame_title, classes.u_ellipsis)}
              onClick={() => this.redirectToFirmWithId(visibleFirmId)}
            >
              {firmName}
            </div>
            <div className={cx(classes.entityProfileFrame_subtitle, classes.u_ellipsis)}>{nContactsStr}</div>
          </div>
        </div>
      </div>
    );
  }
}

const actionProducers = { setIntendedReferrerCompanyId };
export default connect(null, actionProducers)(withStyles(condensedOrgFacePanelStyles)(CondensedOrgFacePanel));
